<mat-toolbar>
    <ion-text>
        Copyright © {{currYr}} U-WIN. All Rights Reserved | version: {{ENV.appVersion}}
    </ion-text>
</mat-toolbar>
  